@if (rule) {
  <nz-collapse nzGhost class="rule-collapse">
    <nz-collapse-panel
      nzCollapsible="icon"
      [nzHeader]="ruleHeader"
      [nzActive]="!collapsed"
      (nzActiveChange)="onActiveChange($event)"
    >
      <div class="rule">
        <div class="rule__description">
          {{
            'agreement.rules.' + rule.calculatorName + '.description'
              | translate
          }}
        </div>
        <div class="rule__details">
          <div>
            <wilson-rule-label
              customLabel="agreement.rules.details.invoice_rule_name.label"
            ></wilson-rule-label>
            <wilson-rule-description
              customDescription="agreement.rules.details.invoice_rule_name.description"
            ></wilson-rule-description>
            <input
              nz-input
              class="rule_details__invoice-rule-name-input"
              [value]="rule.ruleName"
              (change)="setRuleName($event)"
              type="text"
            />
          </div>
          <div class="rule__details__directive_wrapper">
            <ng-template wilsonAgreementRuleDirective></ng-template>
          </div>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <ng-template #ruleHeader>
    <span class="rule__header">
      <span
        class="rule__header__icon"
        nz-icon
        [nzType]="groupIcon()"
        aria-hidden="true"
      ></span>
      <span class="rule__header__title">
        {{ 'agreement.rules.' + rule.calculatorName + '.header' | translate }}
      </span>
      @if (collapsed) {
        @if (summaryFieldSpec(); as spec) {
          <span class="rule__header__summary">
            {{ spec.label }} —
            {{ spec.value | localizedNumber: 'currency' : currency() }}
          </span>
        } @else if (summaryCountSpec(); as countSpec) {
          <span class="rule__header__summary">
            {{
              countSpec.i18nBase
                | translatePlural: countSpec.count : { number: countSpec.count }
            }}
          </span>
        }
      }
    </span>
  </ng-template>
}
